// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"yb","landingPageVideo":"zb","play":"Ab","iframeVideo":"Bb","playHidden":"Cb","playVisible":"Db","fullwidth":"Eb"};